import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n';
import Tracker from '~/src/common/services/Tracker';

import { Results, TabName } from '../../types';
import { focusSearchBar } from '../../utils';

import * as S from './layout';

interface Props {
  results: Results;
  currentTab: TabName;
  setCurrentTab: (tab: TabName) => void;
}

const Header = ({ results, currentTab, setCurrentTab }: Props) => {
  const { term, data } = results;
  const { products, recipes } = data;

  const handleSelectActiveTab = (nextTab: TabName) => {
    if (nextTab === currentTab) return;
    setCurrentTab(nextTab);
    Tracker.sendEvent('click search results tab', { content: nextTab });
  };

  return (
    <S.Container>
      <S.Title onClick={focusSearchBar}>
        <span>{I18n.t('search.results.header.title')}</span> <span>{term}</span>
      </S.Title>
      <S.Tabs>
        <S.Tab
          $active={currentTab === 'products'}
          onClick={() => handleSelectActiveTab('products')}>
          <Icon
            size={16}
            name="apple-normal"
            color={currentTab === 'products' ? 'NEUTRAL_WHITE' : 'ACTION_DEFAULT'}
          />
          {I18n.t('search.results.header.tab.products', { count: products.count ?? '?' })}
        </S.Tab>
        <S.Tab
          $active={currentTab === 'recipes'}
          disabled={recipes.items?.length === 0}
          onClick={() => handleSelectActiveTab('recipes')}>
          <Icon
            size={16}
            name="cooking-hat"
            color={currentTab === 'recipes' ? 'NEUTRAL_WHITE' : 'ACTION_DEFAULT'}
          />
          {I18n.t('search.results.header.tab.recipes', { count: recipes.count ?? '?' })}
        </S.Tab>
      </S.Tabs>
    </S.Container>
  );
};

export default Header;
